export const PHISHING_TUTORIAL_STEP_1 = 'phishing-tutorial-step-1'
export const PHISHING_TUTORIAL_STEP_2 = 'phishing-tutorial-step-2'
export const PHISHING_TUTORIAL_STEP_3 = 'phishing-tutorial-step-3'

export const phishingTutorialSteps = [
  {
    element: '#' + PHISHING_TUTORIAL_STEP_1,
    popover: {
      title: 'O que é Phishing',
      description:
        'Phishing é uma técnica de ataque em que criminosos enviam e-mails falsos para induzir colaboradores a clicar em links maliciosos ou fornecer dados sensíveis. Aqui você simula esses ataques de forma controlada para identificar vulnerabilidades antes que um ataque real aconteça.',
    },
  },
  {
    element: '#' + PHISHING_TUTORIAL_STEP_2,
    popover: {
      title: 'Filtros de campanha',
      description:
        'Use as abas para filtrar as campanhas por status: Todas, Rascunho (não enviadas), Agendado (envio futuro) e Enviado (já disparadas).',
    },
  },
  {
    element: '#' + PHISHING_TUTORIAL_STEP_3,
    popover: {
      title: 'Tabela de campanhas',
      description:
        'Acompanhe o desempenho de cada campanha: e-mails entregues, visualizados, cliques no link e comprometimentos. Clique em Ações (⋮) para visualizar ou editar uma campanha.',
    },
  },
]
